/**
 * Channel list state machine - replaces useChannelStore (Zustand)
 */
import { setup, assign } from 'xstate'
import type { CrmChannel } from '../types'

export interface ChannelListContext {
  channels: CrmChannel[]
  isLoading: boolean
}

export type ChannelListEvent =
  | { type: 'SET_CHANNELS'; channels: CrmChannel[] }
  | { type: 'ADD_CHANNEL'; channel: CrmChannel }
  | { type: 'UPDATE_CHANNEL'; id: string; updates: Partial<CrmChannel> }
  | { type: 'REMOVE_CHANNEL'; id: string }
  | { type: 'SET_LOADING'; loading: boolean }
  | { type: 'CLEAR' }

const machineSetup = setup({
  types: {
    context: {} as ChannelListContext,
    events: {} as ChannelListEvent,
  },
})

export const channelListMachine = machineSetup.createMachine({
  id: 'channelList',
  context: {
    channels: [],
    isLoading: false,
  },
  on: {
    SET_CHANNELS: {
      actions: assign({
        channels: ({ event }) => (event.type === 'SET_CHANNELS' ? event.channels : []),
      }),
    },
    ADD_CHANNEL: {
      actions: assign({
        channels: ({ context, event }) =>
          event.type === 'ADD_CHANNEL' ? [...context.channels, event.channel] : context.channels,
      }),
    },
    UPDATE_CHANNEL: {
      actions: assign({
        channels: ({ context, event }) => {
          if (event.type !== 'UPDATE_CHANNEL') return context.channels
          return context.channels.map((c) => (c.id === event.id ? { ...c, ...event.updates } : c))
        },
      }),
    },
    REMOVE_CHANNEL: {
      actions: assign({
        channels: ({ context, event }) => {
          if (event.type !== 'REMOVE_CHANNEL') return context.channels
          return context.channels.filter((c) => c.id !== event.id)
        },
      }),
    },
    SET_LOADING: {
      actions: assign({
        isLoading: ({ event }) => (event.type === 'SET_LOADING' ? event.loading : false),
      }),
    },
    CLEAR: {
      actions: assign({ channels: [], isLoading: false }),
    },
  },
})
